import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import logo from '../assets/logo.png';

const PaymentReturn = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { user, loading: authLoading } = useAuth();

  const [message, setMessage] = useState('Restoring your session...');
  const [redirecting, setRedirecting] = useState(false);

  useEffect(() => {
    const paymentId = searchParams.get('paymentId');

    console.log('🔄 Payment return page');
    console.log('💳 Payment ID:', paymentId);
    console.log('🔐 Auth loading:', authLoading);
    console.log('👤 User:', user?.uid || 'NO USER');

    // Wait until Firebase finishes restoring authentication
    if (authLoading) {
      setMessage('Verifying your account...');
      return;
    }

    // Firebase has finished checking auth
    if (!user) {
      console.log('❌ No authenticated user after auth initialization');

      setMessage('Please log in to continue...');

      // Give Firebase/app a moment before redirecting
      const timer = setTimeout(() => {
        navigate('/login', { replace: true });
      }, 1000);

      return () => clearTimeout(timer);
    }

    console.log('✅ User authenticated:', user.uid);

    setMessage('Payment received. Opening your wallet...');
    setRedirecting(true);

    // Keep paymentId in the URL so Wallet can process it
    const timer = setTimeout(() => {
      if (paymentId) {
        navigate(`/dashboard/wallet?paymentId=${encodeURIComponent(paymentId)}`, {
          replace: true,
        });
      } else {
        navigate('/dashboard/wallet', {
          replace: true,
        });
      }
    }, 500);

    return () => clearTimeout(timer);
  }, [user, authLoading, searchParams, navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#0A0A0F] to-[#0F0F1A] flex items-center justify-center">
      <div className="text-center">

        <div className="relative w-28 h-28 mx-auto">
          <div className="absolute inset-0 rounded-full animate-spin">
            <div className="w-full h-full rounded-full border-4 border-purple-500/20 border-t-purple-500" />
          </div>

          <div className="absolute inset-0 flex items-center justify-center">
            <img
              src={logo}
              alt="ArenaX"
              className="w-20 h-20 object-contain"
            />
          </div>
        </div>

        <h1 className="mt-6 text-white text-xl font-bold">
          Payment Processing
        </h1>

        <p className="mt-2 text-gray-400">
          {message}
        </p>

        {redirecting && (
          <p className="mt-3 text-sm text-green-400">
            Payment status is being verified...
          </p>
        )}
      </div>
    </div>
  );
};

export default PaymentReturn;